import { API_BASE_URL as BASE } from './apiConfig';
import { createAuthedAxios } from '@/lib/authedAxios';
import type { User } from '@/contexts/AuthContext';

const client = createAuthedAxios({ baseURL: `${BASE}/api/cafe24` });

// B/E 표준 응답({success,message,data})을 언랩 - planApi.ts와 동일 패턴
client.interceptors.response.use((res) => {
  if (res.data && typeof res.data === 'object' && 'success' in res.data && 'data' in res.data) {
    const wrapped = res.data as { success: boolean; message?: string | null; data: unknown };
    res.data = wrapped.data;
  }
  return res;
});

export interface Cafe24MallLinkStatus {
  mallId: string;
  status: 'PENDING_SIGNUP' | 'ACTIVE';
}

export interface Cafe24LaunchAuthData {
  token: string;
  user: User;
  sessionId?: string;
}

export interface Cafe24InstallIntentResult {
  authorizeUrl: string;
}

export async function recordInstallIntent(mallId: string): Promise<Cafe24InstallIntentResult> {
  const res = await client.post<Cafe24InstallIntentResult>('/install-intent', { mallId });
  return res.data;
}

export async function connectComplete(mallId: string): Promise<Cafe24MallLinkStatus> {
  const res = await client.post<Cafe24MallLinkStatus>('/connect-complete', { mallId });
  return res.data;
}

export async function verifyLaunch(queryString: string): Promise<Cafe24LaunchAuthData> {
  const res = await client.post<Cafe24LaunchAuthData>('/launch/verify', { queryString });
  return res.data;
}
